export const translate = (text: string, lang: any) => {
  if (lang == '') {
    if (sessionStorage.getItem('lang') != '') {
      lang = sessionStorage.getItem('lang');
    }
  }
  if (lang.toString().length > 1) {
    var langKey = 0;
    switch (lang) {
      case 'tr':
        langKey = 0;
        break;
      case 'en':
        langKey = 2;
      case 'fr':
        langKey = 3;
        break;
      case 'de':
        langKey = 6;
        break;
    }
    lang = langKey;
  }

  var result = '';
  var arrays = [
    [
      'Lütfen e-mail adresinizi giriniz',
      '',
      'Please enter your email address',
      '',
      '',
      'ar',
      'Geben Sie bitte Ihre Email-Adresse ein',
    ],
    [
      'Lütfen sözleşmeleri okuyun ve onaylayın',
      '',
      'Please read and approve the contracts',
      '',
      '',
      'ar',
      'Bitte lesen und genehmigen Sie die Verträge',
    ],
    [
      'Please fill in all fields',
      '',
      'Please fill in all fields',
      '',
      '',
      'ar',
      'Bitte füllen Sie alle Felder aus',
    ],
    [
      'Zaten üyesiniz. Oturum açmanız gerekecek. <br> <br> Parolanızı unuttuysanız, Parolamı Unuttuma tıklayarak sıfırlayabilirsiniz.',
      '',
      "You are already a member. You'll need to sign in. <br> <br> If you've forgotten your password, you can reset it by clicking Forgot Password.",
      '',
      '',
      'ar',
      'Du bist bereits Mitglied. Sie müssen sich anmelden.<br><br>Wenn Sie Ihr Passwort vergessen haben, können Sie es zurücksetzen, indem Sie auf Passwort vergessen klicken.',
    ],
    [
      'Kaydınız tamamlandı.',
      '',
      'Your registration is complete.',
      '',
      '',
      'ar',
      'Ihre Anmeldung ist vollständig.',
    ],
    [
      'ZORUNLU GİRİŞ',
      '',
      'MANDATORY SIGN IN ',
      '',
      '',
      'ar',
      'VERBINDLICH ANMELDEN',
    ],
    [
      'One or more errors occurred. Please try again later.',
      '',
      'One or more errors occurred. Please try again later.',
      '',
      '',
      'ar',
      'Ein oder mehrere Fehler sind aufgetreten. Bitte versuchen Sie es später noch einmal.',
    ],
    ['Please wait.', '', 'Please wait', '', '', 'ar', 'Warten Sie mal'],
    [
      'You are not a member.',
      '',
      'You are not a member.',
      '',
      '',
      'ar',
      'Sie sind kein Mitglied.',
    ],
    [
      'Username or password is incorrect',
      '',
      'Username or password is incorrect',
      '',
      '',
      'ar',
      'Benutzername oder Passwort ist falsch',
    ],
    [
      'Lütfen indirim kodunu giriniz',
      '',
      'Please enter the discount code',
      '',
      '',
      'ar',
      'Bitte geben Sie den Rabattcode ein',
    ],
    [
      'İndirim kodu silindi',
      '',
      'Discount code deleted',
      '',
      '',
      'ar',
      'Rabattcode gelöscht',
    ],
    [
      'Fiyatta indirim',
      '',
      'Discount on the price ',
      '',
      '',
      'ar',
      'Rabatt auf den Preis',
    ],
    [
      'Bu indirim kodunu kullanamazsınız',
      '',
      'You cannot use this discount code',
      '',
      '',
      'ar',
      'Sie können diesen Rabattcode nicht verwenden',
    ],
    [
      'İndirim kodu uygulandı',
      '',
      'Discount code applied',
      '',
      '',
      'ar',
      'Rabattcode angewendet',
    ],
    [
      'Şifre 3 karakterden az olmamalıdır',
      '',
      'The password must not contain less than 3 characters',
      '',
      '',
      'ar',
      'Das Passwort darf nicht weniger als 3 Zeichen enthalten',
    ],
    [
      'Parolalar uyuşmuyor ',
      '',
      'Passwords do not match ',
      '',
      '',
      'ar',
      'Passwörter stimmen nicht überein',
    ],
    [
      'Profiliniz güncellenecektir.',
      '',
      'Your profile will be updated.',
      '',
      '',
      'ar',
      'Ihr Profil wird aktualisiert.',
    ],
    [
      'sizin isteğiniz alındı',
      '',
      'Your request has been received',
      '',
      '',
      'ar',
      'Ihre Anfrage wurde empfangen',
    ],
    [
      'Mesajınız gönderiliyor, lütfen bekleyin',
      '',
      'Your message is being sent, please wait',
      '',
      '',
      'ar',
      'Ihre Nachricht wird gesendet, bitte warten ',
    ],
    [
      'Mesajınız gönderildi.',
      '',
      'Your message has been sent.',
      '',
      '',
      'ar',
      'Ihre Nachricht wurde versendet.',
    ],
    [
      'Yeni Katılımcı Bilgisi',
      '',
      'New Participant ',
      '',
      '',
      'ar',
      'Neu Teilnehmer',
    ],
    [
      'Katılımcı bilgisi kayıt edildi',
      '',
      'Participant information saved',
      '',
      '',
      'ar',
      'Teilnehmerinformationen gespeichert',
    ],
    [
      'Etkinlik maksimum katılımcı sayısına ulaştığı için daha fazla katılımcı ekleyemezsiniz.',
      '',
      'You cannot add more attendees because the event has reached the maximum number of attendees.',
      '',
      '',
      'ar',
      'Sie können keine weiteren Teilnehmer hinzufügen, da die Veranstaltung die maximale Teilnehmerzahl erreicht hat.',
    ],
    [
      'Lütfen katılımcı bilgisi giriniz',
      '',
      'Please enter participant information',
      '',
      '',
      'ar',
      'Bitte geben Sie die Teilnehmerdaten ein',
    ],
    [
      'Katılımcı sayısı etkinlikteki boş yer sayısını aşıyor. Lütfen katılımcı sayısını kontrol ediniz.',
      '',
      'The number of participants exceeds the number of vacancies in the event. Please check the number of participants.',
      '',
      '',
      'ar',
      'Die Anzahl der Teilnehmer übersteigt die Anzahl der freien Plätze in der Veranstaltung. Bitte überprüfen Sie die Teilnehmerzahl.',
    ],
    [
      'Etkinlik maksimum katılımcı sayısına ulaştığı için kaydınız tamamlanamadı.',
      '',
      'Your registration could not be completed because the event has reached the maximum number of participants.',
      '',
      '',
      'ar',
      'Ihre Anmeldung konnte nicht abgeschlossen werden, da die Veranstaltung die maximale Teilnehmerzahl erreicht hat.',
    ],
    [
      'Bu e-posta adresi ile bir katılımcı bilgisi bulunuyor. Bu e-posta adresini tekrar giremezsiniz.',
      '',
      'There is a participant information with this e-mail address. You cannot re-enter this email address.',
      '',
      '',
      'ar',
      'Zu dieser E-Mail-Adresse gibt es eine Teilnehmerinformation. Sie können diese E-Mail-Adresse nicht erneut eingeben.',
    ],
    ['tr', '', 'en', '', '', 'ar', 'de'],
    ['tr', '', 'en', '', '', 'ar', 'de'],
    ['tr', '', 'en', '', '', 'ar', 'de'],
    ['tr', '', 'en', '', '', 'ar', 'de'],
    ['tr', '', 'en', '', '', 'ar', 'de'],
    ['tr', '', 'en', '', '', 'ar', 'de'],
    ['tr', '', 'en', '', '', 'ar', 'de'],
    ['tr', '', 'en', '', '', 'ar', 'de'],
    ['tr', '', 'en', '', '', 'ar', 'de'],

    /*
          Das Produkt ist nicht vorrätig.
          Bitte wählen Sie Farb- und Leistungsinformationen
          Teile wurden Ihrem Warenkorb hinzugefügt.
          Das Produkt wurde aus Ihrem Warenkorb entfernt
          Nicht vorrätiges Produkt wurde aus Ihrem Warenkorb entfernt.
          Die Bestände der Produkte in Ihrem Warenkorb wurden aktualisiert und die nicht vorrätigen Produkte wurden entfernt.
          Es befinden sich keine Artikel in Ihrem Warenkorb. 
      */
  ];
  for (var i = 0; i < arrays.length; i++) {
    if (arrays[i][0] == text) {
      result = arrays[i][lang];
    }
  }
  if (result == '') {
    result = text;
  }
  return result;
};
